import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { GiftCard } from './gift-card'
import { giftCardActions } from './gift-card.actions'
import * as fromGiftCard from './gift-card.reducer'
import { GiftCardService } from './gift-card.service'

@Injectable()
export class GiftCardEffects extends ResourceEffects<GiftCard> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public giftCardService: GiftCardService
  ) {
    super(fromGiftCard.FEATURE_NAME, giftCardService, giftCardActions, actions$)
  }
}
